import { Box, Typography } from '@mui/material';
import React from 'react';
import logoAlertAiEducation from '../../../../assets/images/favicon.png';
import walpaperAdventista from '../../../assets/adventista.jpg';

interface PdfViewerFifthProps {
  formData: {
    notes: string;
    implementationFee: string;
  };
  boxRef: React.RefObject<HTMLDivElement>;
  implementationFee?: string;
  servicesRows: {
    recurso: string;
    qtde: string;
    meses12: string;
    meses24: string;
    meses36: string;
    meses48: string;
    meses60: string;
  }[];
  formType: 'completo' | 'simples';
  setFormType: React.Dispatch<React.SetStateAction<'completo' | 'simples'>>;
}

const PdfViewerFifth: React.FC<PdfViewerFifthProps> = ({
  formData,
  boxRef,
  servicesRows,
  implementationFee,
  formType,
  setFormType,
}) => {
  return (
    <Box
      sx={{
        width: '95vw',
        height: '90vh',
        maxWidth: 'calc(93vh * 0.700)',
        aspectRatio: '1 / 1.414',
        backgroundColor: 'white',
        boxShadow: '0 2px 12px rgba(0,0,0,0.10)',
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
        margin: 'auto',
        position: 'relative',
      }}
      ref={boxRef}
    >
      <Box
        sx={{
          height: '100%',
          width: '7vh',
          backgroundColor: '#224FA2',
        }}
      />

      <div style={{ width: '100%' }}>
        <Typography
          sx={{
            fontSize: '2.5rem',
            width: '60%',
            fontWeight: 'bold',
            color: '#224FA2',
            marginBottom: '5px',
            lineHeight: 1,
            paddingLeft: '24px',
          }}
        >
          Proposta
        </Typography>
        <Typography
          sx={{
            fontSize: '1rem',
            width: '60%',
            fontWeight: 'bold',
            color: '#224FA2',
            marginBottom: '1rem',
            lineHeight: 1,
            paddingLeft: '24px',
          }}
        >
          LISTA DE EQUIPAMENTOS
        </Typography>
        <Box
          sx={{
            width: '40%',
            height: '5px',
            marginLeft: '24px',
            marginBottom: '2rem',
            backgroundColor: '#54B55D',
            zIndex: 1,
          }}
        />
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'flex-start',
            paddingLeft: '25px',
            marginBottom: '1rem',
          }}
        >
          <Typography
            sx={{
              fontSize: '0.8rem',
              width: '100%',
              fontWeight: 'bold',
              color: '#224FA2',
              marginBottom: '1rem',
              lineHeight: 1,
            }}
          >
            {formType === 'completo'
              ? 'Total de serviços (Hardware + Software) POR ALUNO'
              : 'Total de serviços (Software)'}
          </Typography>

          {formType === 'completo' ? (
            <table style={{ borderCollapse: 'collapse', maxWidth: 120 }}>
              <thead>
                <tr>
                  {[
                    'Recursos',
                    'Qtde',
                    '12 meses',
                    '24 meses',
                    '36 meses',
                    '48 meses',
                    '60 meses',
                  ].map((label, i) => (
                    <th
                      key={i}
                      style={{
                        border: '0.5px solid #224FA2',
                        padding: '8px 8px',
                        fontWeight: 'bold',
                        color: '#224FA2',
                        fontSize: '0.5rem',
                        background: '#F5F8FF',
                        textAlign: 'left',
                      }}
                    >
                      {label}
                    </th>
                  ))}
                </tr>
              </thead>
              <tbody>
                {servicesRows && servicesRows.length > 0
                  ? servicesRows.map((row, idx) => (
                      <tr key={idx}>
                        {[
                          row.recurso,
                          row.qtde,
                          row.meses12,
                          row.meses24,
                          row.meses36,
                          row.meses48,
                          row.meses60,
                        ].map((cell, colIdx) => (
                          <td
                            key={colIdx}
                            style={{
                              border: '0.5px solid #224FA2',
                              padding: '10px',
                              fontWeight: 'normal',
                              color: 'gray',
                              fontSize: '0.3rem',
                              height: '5px',
                              minWidth: colIdx === 0 ? 120 : 40,
                              width: colIdx === 0 ? 60 : undefined,
                            }}
                          >
                            {cell}
                          </td>
                        ))}
                      </tr>
                    ))
                  : [...Array(1)].map((_, idx) => (
                      <tr key={idx}>
                        {[...Array(7)].map((_, colIdx) => (
                          <td
                            key={colIdx}
                            style={{
                              border: '0.5px solid #224FA2',
                              padding: '10px',
                              fontWeight: 'normal',
                              color: 'gray',
                              fontSize: '0.3rem',
                              height: '5px',
                              minWidth: colIdx === 0 ? 120 : 40,
                              width: colIdx === 0 ? 60 : undefined,
                            }}
                          >
                            Teste
                          </td>
                        ))}
                      </tr>
                    ))}
              </tbody>
            </table>
          ) : (
            <table style={{ borderCollapse: 'collapse', maxWidth: 350 }}>
              <thead>
                <tr>
                  <th
                    style={{
                      border: '0.5px solid #224FA2',
                      padding: '8px 40px',
                      fontWeight: 'bold',
                      color: '#224FA2',
                      fontSize: '0.5rem',
                      background: '#F5F8FF',
                      textAlign: 'left',
                    }}
                  >
                    Descrição do Serviço
                  </th>
                  <th
                    style={{
                      border: '0.5px solid #224FA2',
                      padding: '8px 20px',
                      fontWeight: 'bold',
                      color: '#224FA2',
                      fontSize: '0.5rem',
                      background: '#F5F8FF',
                      textAlign: 'left',
                    }}
                  >
                    Valor
                  </th>
                </tr>
              </thead>
              <tbody>
                {servicesRows && servicesRows.length > 0
                  ? servicesRows.map((row, idx) => (
                      <tr key={idx}>
                        <td
                          style={{
                            border: '0.5px solid #224FA2',
                            padding: '10px',
                            fontWeight: 'normal',
                            color: 'gray',
                            fontSize: '0.4rem',
                          }}
                        >
                          {row.recurso}
                        </td>
                        <td
                          style={{
                            border: '0.5px solid #224FA2',
                            padding: '10px',
                            fontWeight: 'normal',
                            color: 'gray',
                            fontSize: '0.4rem',
                          }}
                        >
                          {row.qtde}
                        </td>
                      </tr>
                    ))
                  : [...Array(1)].map((_, idx) => (
                      <tr key={idx}>
                        <td
                          style={{
                            border: '0.5px solid #224FA2',
                            padding: '10px',
                            fontWeight: 'normal',
                            color: 'gray',
                            fontSize: '0.3rem',
                          }}
                        >
                          Teste Serviço
                        </td>
                        <td
                          style={{
                            border: '0.5px solid #224FA2',
                            padding: '10px',
                            fontWeight: 'normal',
                            color: 'gray',
                            fontSize: '0.3rem',
                          }}
                        >
                          R$ 0,00
                        </td>
                      </tr>
                    ))}
              </tbody>
            </table>
          )}
        </Box>
        <Box
          sx={{
            display: 'flex',
            justifyContent: 'flex-start',
            paddingLeft: '25px',
            marginBottom: '1rem',
          }}
        >
          <table style={{ borderCollapse: 'collapse' }}>
            <thead>
              <tr>
                <th
                  style={{
                    border: '1px solid #224FA2',
                    padding: '6px 108px',
                    fontWeight: 'bold',
                    color: '#224FA2',
                    height: '10px',
                    fontSize: '0.8rem',
                    background: '#F5F8FF',
                    textAlign: 'center',
                  }}
                >
                  Taxa de implementação
                </th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td
                  style={{
                    border: '1px solid #224FA2',
                    padding: '10px 105108pxpx',
                    fontWeight: 'bold',
                    height: '10px',
                    color: 'gray',
                    fontSize: '0.8rem',
                    textAlign: 'center',
                  }}
                >
                  {formData.implementationFee}
                </td>
              </tr>
            </tbody>
          </table>
        </Box>
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'row',
            alignItems: 'center',
            justifyContent: 'flex-start',
            width: '100%',
            height: '1vh',
            marginBottom: '1rem',
            paddingLeft: '25px',
          }}
        >
          <Typography
            sx={{
              fontSize: '0.7rem',
              width: '100%',
              fontWeight: 'bold',
              color: '#224FA2',
              lineHeight: 1,
            }}
          >
            Manifesto a aceitação da proposta referida, nos valores, quantidades
            e condições de pagamento previstas na proposta comercial em anexo.
          </Typography>
        </Box>
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'flex-start',
            width: '90%',
            marginLeft: '20px',
            marginBottom: '1rem',
            gap: 1,
            border: '1px solid #224FA2',
            padding: '16px',
          }}
        >
          <Typography
            sx={{
              fontSize: '0.7rem',
              lineHeight: 1,
              color: '#224FA2',
              fontWeight: 'bold',
            }}
          >
            Nome:
          </Typography>
          <Typography
            sx={{
              fontSize: '0.7rem',
              lineHeight: 1,
              color: '#224FA2',
              fontWeight: 'bold',
            }}
          >
            CNPJ:
          </Typography>
          <Typography
            sx={{
              fontSize: '0.7rem',
              lineHeight: 1,
              color: '#224FA2',
              fontWeight: 'bold',
            }}
          >
            Data:
          </Typography>
          <Typography
            sx={{
              fontSize: '0.7rem',
              lineHeight: 1,
              color: '#224FA2',
              fontWeight: 'bold',
            }}
          >
            Assinatura:
          </Typography>
          <Typography
            sx={{
              fontSize: '0.7rem',
              color: '#224FA2',
              fontWeight: 'bold',
              lineHeight: 1,
              mt: 1,
            }}
          >
            Desejo incluir o serviço de chamada de aluno:
            <span style={{ marginLeft: 8 }}>( )Sim&nbsp;&nbsp;( )Não</span>
          </Typography>
          <Typography
            sx={{ fontSize: '0.7rem', color: '#224FA2', fontWeight: 'bold' }}
          >
            Quantidade de salas:
          </Typography>
        </Box>
      </div>
    </Box>
  );
};

export default PdfViewerFifth;
